import { createContext } from 'react';
import { ReadOnlyURLSearchParams } from './ReadOnlyURLSearchParams';
import type { History } from '../fork/history';
import { type HistoryBasePath } from '../globalState';

export type { HistoryBasePath };

export const SearchParamsContext =
  createContext<ReadOnlyURLSearchParams | null>(null);
SearchParamsContext.displayName = 'SearchParamsContext';

export const PathnameContext = createContext<string | null>(null);
PathnameContext.displayName = 'PathnameContext';

export const HistoryContext = createContext<History | null>(null);
HistoryContext.displayName = 'HistoryContext';

export const HistoryBasePathContext = createContext<HistoryBasePath | null>(
  null
);
HistoryBasePathContext.displayName = 'HistoryBasePathContext';
